module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_4-52e3226519a36aeba34791fb19ab51b4.webp";